export default __webpack_public_path__ + "static/media/registration.6569c7b1.jpg";